module.exports = __webpack_public_path__ + "static/pw_case-bc79637d1e69392e968eaa05fba57b9d.webp";